import React from 'react'
import propTypes from 'prop-types'
import { observer } from 'mobx-react'
import { Field, FieldArray } from 'formik'
import get from 'lodash/get'

import Input from './Input'
import RepeatableAction from './RepeatableAction'

const createEmptyLinksObject = () => ({ professionalLinkUrl: '' })

const ProfessionalLinkFields = ({ form, name, label, inputProps }) => {
  let professionalLinks = get(form.values, name)
  if (professionalLinks.length === 0) {
    professionalLinks = [createEmptyLinksObject()]
  }

  return (
    <div className='expert-form__input-group'>
      <label className='expert-form__label'>{label}</label>
      <div className='expert-form__input-wrapper'>
        <FieldArray
          name={name}
          render={arrayHelpers => (
            <div className='expert-form__repeatable-input-wrapper'>
              {professionalLinks.map((link, index) => (
                <div className='expert-form__repeatable-input' key={index}>
                  <Field
                    name={`${name}[${index}].professionalLinkUrl`}
                    placeholder=''
                    value={professionalLinks[index].professionalLinkUrl}
                    component={Input}
                    {...inputProps}
                  />
                  <RepeatableAction
                    fieldValues={professionalLinks}
                    arrayHelpers={arrayHelpers}
                    index={index}
                    initialObject={createEmptyLinksObject()}
                  />
                </div>
              ))}
            </div>
          )}
        />
      </div>
    </div>
  )
}

ProfessionalLinkFields.propTypes = {
  form: propTypes.object,
  name: propTypes.oneOfType([propTypes.string, propTypes.array]),
  label: propTypes.string,
  inputProps: propTypes.object
}

export default observer(ProfessionalLinkFields)
